export default __webpack_public_path__ + "static/media/success.456b74c4.png";